"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PersonType;
(function (PersonType) {
    PersonType[PersonType["Unknown"] = 0] = "Unknown";
    PersonType[PersonType["User"] = 1] = "User";
    PersonType[PersonType["Bot"] = 2] = "Bot";
})(PersonType || (PersonType = {}));
exports.default = PersonType;
//# sourceMappingURL=PersonType.js.map